// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__NSo1I","AuthDiv":"Auth_AuthDiv__3vGPy","Button":"Auth_Button__eFRCY","Messages":"Auth_Messages__K12Gg","Link":"Auth_Link__jrO2E"};